module.exports = __webpack_public_path__ + "img/AiCheff.c28f3263.png";